export const configurationFile = {
  production: {
    DOMAIN_NAME: "https://fapool.ir/",
    API_DOMAIN_NAME: "https://fapool.ir/api/",
    UPLOAD_DOMAIN_NAME: "https://dl.fapool.ir/",
  },
  staging: {
    DOMAIN_NAME: "",
    API_DOMAIN_NAME: ""

  },
  development: {
    DOMAIN_NAME: "https://dev.fapool.ir/",
    API_DOMAIN_NAME: "https://dev.fapool.ir/api/",
    UPLOAD_DOMAIN_NAME: "https://dl.fapool.ir/",
  },
  test: {
    DOMAIN_NAME: "",
    API_DOMAIN_NAME: ""
  },
  rbac: false
};
